
define(function(require, exports, module) {
    'use strict';
    var $ = require('j');
    var _ = require('underscore');
    var core = require('core');
    var gameTracker = require('modules/trackers/game.tracker.instance');

    module.exports = {
        events: {
            'tap .fn-launch-game': '_handleGameItemTap'
        },

        _handleGameItemTap: function(event) {
            var $gameLaunchElement = $(event.currentTarget);
            var containerId = $gameLaunchElement.parents('.portlet-wrapper').data('portletId');
            var feedName = $gameLaunchElement.parents('.fn-games').data('feedName');
            var webContentId = gameTracker.getWebContentId($gameLaunchElement);
            var activeCategory = null;

            if (this.options && this.options.categories) {
                activeCategory = _.find(this.options.categories, function(cat) {
                    return cat.active;
                });
            }

            var gameWillBePlayedMaybe = {
                gameCode: $gameLaunchElement.data('gameCode'),
                container: containerId,
                feedName: feedName,
                webContentId: webContentId
            };

            if (activeCategory) {
                _.extend(gameWillBePlayedMaybe, {
                    category: activeCategory
                });
            }

            core.trigger('game:launch:maybe', gameWillBePlayedMaybe);
        }
    };

});
